import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import { FormHelperText } from '@material-ui/core';
import { ErrorMessage } from 'formik';
import { useUnitScales } from 'hook/units/scales';
import { customStyles } from './styles';
import moment from 'moment';

const CustomSelectUnitScales = ({
  name,
  field,
  placeholder,
  handleChange,
  value,
  menuList,
  errors,
  showCount = false,
  isMulti = false,
  isClearable = false,
  unit_id = null,
}) => {
  const { data, total, loading, getList } = useUnitScales();
  const page_ref = useRef(1);

  const [filter, setFilter] = useState({
    page: 1,
    per_page: 60,
    search: '',
    date_start: showCount ? moment().day(1).format('yyyy-MM-DD') : undefined,
    date_end: showCount ? moment().day(7).format('yyyy-MM-DD') : undefined,
  });
  const { page, per_page } = filter;

  const [formattedLabels, setFormattedLabels] = useState([]);

  const searchItem = (unitValue) => {
    setFilter((oldState) => ({
      ...oldState,
      page: 1,
      search: unitValue,
    }));
  };

  const pagination = () => {
    const totalPage = Math.ceil(total / per_page);
    const nextPage = page_ref.current + 1;
    if (page < totalPage && page_ref.current < totalPage) {
      setFilter((oldState) => ({
        ...oldState,
        page: nextPage,
      }));

      page_ref.current = nextPage;
    }
  };

  const toTopPagination = () => {
    if (per_page > 1) {
      let prevPage = page_ref.current - 1;
      prevPage = prevPage > 0 ? prevPage : 1;
      setFilter((oldState) => ({
        ...oldState,
        page: prevPage,
      }));

      page_ref.current = prevPage;
    }
  };

  useEffect(() => {
    if (unit_id) getList({ unit_id }, filter);
  }, [filter, unit_id]);

  useEffect(() => {
    if (data && data.length > 0) {
      const labelScale = data.map((scale) => ({
        labelSelected: showCount ? scale.name : undefined,
        label: `${scale.name}${
          showCount
            ? ` - ${scale.count_agenda} ${
                scale.count_agenda > 1 || scale.count_agenda === 0
                  ? 'plantões'
                  : 'plantão'
              }`
            : ''
        }`,
        value: scale.id,
        status: scale.status,
      }));
      setFormattedLabels(labelScale.filter((item) => item.status !== 0));
    } else {
      setFormattedLabels([]);
    }
  }, [data]);

  useEffect(() => {
    return () => {
      setFormattedLabels([]);
    };
  }, []);

  return (
    <>
      <Select
        placeholder={placeholder}
        id={placeholder}
        isLoading={loading}
        loadingMessage={() => 'Carregando'}
        styles={customStyles(menuList)}
        name={name}
        options={formattedLabels}
        onInputChange={searchItem}
        onMenuScrollToBottom={pagination}
        onMenuScrollToTop={toTopPagination}
        onChange={handleChange}
        value={value}
        noOptionsMessage={() => 'Nenhum resultado encontrado'}
        isMulti={isMulti}
        isClearable={isClearable}
      />
      {field ? (
        <ErrorMessage name={field.name}>
          {() => (
            <FormHelperText error id="component-error-text">
              {errors}
            </FormHelperText>
          )}
        </ErrorMessage>
      ) : (
        <>
          {errors && (
            <ErrorMessage name={name}>
              {() => (
                <FormHelperText error id="component-error-text">
                  {errors}
                </FormHelperText>
              )}
            </ErrorMessage>
          )}
        </>
      )}
    </>
  );
};
export default CustomSelectUnitScales;
